import React, { Component, Fragment } from "react";
import * as Sentry from "@sentry/react";
import ERROR_IMAGE from "../../../assets/images/error.png";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  restart = () => {
    localStorage.clear();
    window.location.replace("/");
  };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error, errorInfo);
    // logging error into sentry
    Sentry.captureException(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Fragment>
          <div className="bg-light error-boundary">
            <div className="d-flex justify-content-center align-items-center flex-column px-3">
              <img className="w-75" src={ERROR_IMAGE} alt="BVS" />
              <h4 className="not-found__info w-100 text-center mt-4 m-0">
                Something went wrong
              </h4>
              <div className="d-flex justify-content-center align-items-between flex-row flex-wrap mt-4">
                <button
                  className="contact-us-hero-button"
                  onClick={this.restart}
                >
                  Reload
                </button>
              </div>
            </div>
          </div>
        </Fragment>
      );
    }

    return this.props.children;
  }
}
export default ErrorBoundary;
